/* moose.lighting — My Projects, interface layer.
   Depends on moose-projects.js (window.MooseProjects).

   Three surfaces:
     1. the Add to Project control on a product page
     2. the header count
     3. /pages/my-projects, which renders three views from the URL:
          ?shared=<token>   a project someone sent you, read only
          ?project=<id>     one of your projects
          (nothing)         all of your projects
*/
(function () {
  'use strict';

  var P = window.MooseProjects;
  var U = window.MooseProjectsInternal;
  if (!P || !U) return;

  var esc = U.esc, money = U.money, fetchProduct = U.fetchProduct;

  /* Shopify serves whatever size you ask for. Without this the page pulls the
     ORIGINAL file for every thumbnail: the images on this store are named
     "-full.jpg" and are multiple megabytes each. A twenty fixture project
     would have downloaded twenty full-resolution photographs to draw twenty
     96px squares. */
  function sized(src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* ----------------------------------------------------------------- toast */

  function toast(msg, kind) {
    var el = document.createElement('div');
    el.className = 'mp-toast' + (kind ? ' mp-toast--' + kind : '');
    el.textContent = msg;
    document.body.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-on'); });
    setTimeout(function () {
      el.classList.remove('is-on');
      setTimeout(function () { el.remove(); }, 300);
    }, 2600);
  }

  /* ----------------------------------------------------------------- modal */

  var modal = null;

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-on');
    var m = modal;
    modal = null;
    setTimeout(function () { m.remove(); }, 200);
  }

  function openModal(title, bodyHtml, onMount) {
    closeModal();
    modal = document.createElement('div');
    modal.className = 'mp-veil';
    modal.innerHTML =
      '<div class="mp-card" role="dialog" aria-modal="true" aria-label="' + esc(title) + '">' +
        '<button class="mp-x" type="button" aria-label="Close">&times;</button>' +
        '<h2 class="mp-h">' + esc(title) + '</h2>' +
        '<div class="mp-body"></div>' +
      '</div>';
    modal.querySelector('.mp-body').innerHTML = bodyHtml;
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });
    modal.querySelector('.mp-x').addEventListener('click', closeModal);
    document.body.appendChild(modal);
    requestAnimationFrame(function () { modal.classList.add('is-on'); });
    if (onMount) onMount(modal.querySelector('.mp-body'));
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  /* --------------------------------------------- add to project, product page */

  function pickerHtml(variantId) {
    var list = P.all();
    var rows = list.map(function (p) {
      var inIt = p.items.some(function (x) { return x.v === parseInt(variantId, 10); });
      return '<button class="mp-pick" type="button" data-id="' + esc(p.id) + '"' +
        (inIt ? ' data-in="1"' : '') + '>' +
        '<span class="mp-pick__n">' + esc(p.name) + '</span>' +
        '<span class="mp-pick__c">' + p.items.length + (p.items.length === 1 ? ' item' : ' items') + '</span>' +
        '<span class="mp-pick__t">' + (inIt ? 'Added' : 'Add') + '</span>' +
        '</button>';
    }).join('');
    if (!list.length) {
      rows = '<p class="mp-empty">You have no projects yet. Name your first one below. ' +
             'A project is usually a room or a job: Kitchen, Master Bath, Chatham Street.</p>';
    }
    return '<div class="mp-picks">' + rows + '</div>' +
      '<form class="mp-new"><label class="mp-lab" for="mp-new-name">New project</label>' +
      '<div class="mp-row"><input id="mp-new-name" class="mp-in" type="text" maxlength="60" ' +
      'placeholder="Kitchen remodel" autocomplete="off"><button class="mp-btn" type="submit">Create &amp; add</button></div></form>';
  }

  function openPicker(variantId, handle) {
    openModal('Add to a project', pickerHtml(variantId), function (body) {
      body.addEventListener('click', function (e) {
        var btn = e.target.closest('.mp-pick');
        if (!btn) return;
        if (btn.getAttribute('data-in')) {
          toast('Already in ' + P.get(btn.dataset.id).name);
          return;
        }
        P.addItem(btn.dataset.id, variantId, handle, 1);
        closeModal();
        toast('Added to ' + P.get(btn.dataset.id).name, 'ok');
      });
      var form = body.querySelector('.mp-new');
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var name = body.querySelector('#mp-new-name').value;
        var p = P.create(name);
        if (!p) { toast('That is a lot of projects. Tidy some up first.'); return; }
        P.addItem(p.id, variantId, handle, 1);
        closeModal();
        toast('Added to ' + p.name, 'ok');
      });
    });
  }

  /* The button is injected rather than added as a theme block.

     A JSON template setting is stored text, not Liquid, so a {% render %} tag
     placed in one is printed, never executed. The theme's own buttons live in
     snippets/product-page-get-buttons.liquid, a 27KB file, and editing that
     for one button is surgery that a theme update would undo. Injecting next
     to the existing wishlist and compare buttons costs nothing and survives. */

  function currentVariantId() {
    /* Read at call time, never at load: this theme swaps variants without
       reloading, and there are several [name="id"] selects on the page from
       related products and quick views. Only the one inside the product info
       block belongs to the fixture being viewed. */
    var sel = document.querySelector('.product-page-info [name="id"]') ||
              document.querySelector('.product-page-info__form [name="id"]');
    if (sel && sel.value) return sel.value;
    var fromUrl = new URLSearchParams(location.search).get('variant');
    if (fromUrl) return fromUrl;
    if (window.meta && meta.product && meta.product.variants && meta.product.variants.length === 1) {
      return meta.product.variants[0].id;
    }
    return null;
  }

  function currentHandle() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }

  function mountProductButton() {
    if (!/\/products\//.test(location.pathname)) return;
    if (document.querySelector('[data-mp-add]')) return;
    var anchor = document.querySelector('.product-page-info__button-add-to-compare') ||
                 document.querySelector('.product-page-info__button-add-to-wishlist');
    if (!anchor) return;
    var wrap = document.createElement('div');
    wrap.className = 'product-page-info__button-add-to-project mb-10';
    wrap.innerHTML =
      '<button type="button" class="btn btn--full mp-add mp-add--full" data-mp-add>' +
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M20 6h-8l-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm-7 9h-2v2h-2v-2H7v-2h2v-2h2v2h2v2z"/>' +
      '</svg><span>Add to Project</span></button>';
    anchor.insertAdjacentElement('afterend', wrap);
  }

  function wireProductButtons() {
    mountProductButton();
    /* The theme re-renders this block on a variant change, which would take
       the button with it. Put it back when that happens. */
    var host = document.querySelector('.product-page-info');
    if (host && window.MutationObserver) {
      var mo = new MutationObserver(function () { mountProductButton(); });
      mo.observe(host, { childList: true, subtree: true });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-mp-add]');
      if (!btn) return;
      e.preventDefault();
      var variantId = btn.getAttribute('data-variant-id') || currentVariantId();
      var handle = btn.getAttribute('data-handle') || currentHandle();
      if (!variantId || !handle) { toast('Could not tell which fixture that is.'); return; }
      openPicker(variantId, handle);
    });
  }

  /* ------------------------------------------------------------ header count */

  function paintCount() {
    var n = P.totalItems();
    document.querySelectorAll('[data-mp-count]').forEach(function (el) {
      /* the header badge matches the theme's wishlist and compare counters,
         which hide themselves at zero; anywhere else the count reads as a
         suffix and stays blank when empty */
      var isBadge = el.getAttribute('data-mp-count') === 'badge';
      el.textContent = isBadge ? String(n) : (n ? '(' + n + ')' : '');
      /* the theme hides its own zero counters with a CSS rule keyed to
         data-js-wishlist-count="0", which this element no longer carries */
      if (isBadge) el.style.display = n ? '' : 'none';
    });
  }

  /* The header entry is CLONED from the theme's own wishlist button rather
     than written from scratch. That button carries a stack of theme classes
     and a count element whose styling lives somewhere in a 200KB stylesheet.
     Cloning inherits all of it exactly, including the sticky-header variant,
     so the new entry cannot drift from the three beside it. */
  function mountHeaderLink() {
    if (document.querySelector('[data-mp-header]')) return;
    var cart = document.querySelector('.header__btn-cart');
    var model = document.querySelector('.header__btn-wishlist');
    if (!cart || !model || !model.parentElement) return;

    var wrap = model.parentElement.cloneNode(true);
    var a = wrap.querySelector('a');
    if (!a) return;

    a.className = a.className
      .replace('header__btn-wishlist', 'header__btn-projects')
      .replace('js-popup-button', '');
    a.setAttribute('href', '/pages/my-projects');
    a.setAttribute('title', 'My Projects');
    a.setAttribute('aria-label', 'My Projects');
    a.setAttribute('data-mp-header', '');
    a.removeAttribute('data-js-popup-button');
    a.removeAttribute('data-js-sticky-replace-element');
    a.removeAttribute('data-tippy-content');

    var svg = a.querySelector('svg');
    if (svg) {
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('class', 'icon icon-mp-projects');
      /* The three icons beside this one are thin outlines. A solid silhouette
         sat heavier than them, so this is stroked instead. Inline style,
         because the theme sets fill on .icon from its own stylesheet. */
      svg.setAttribute('style', 'fill:none;stroke:currentColor;stroke-width:1.6;' +
                                'stroke-linecap:round;stroke-linejoin:round');
      svg.innerHTML =
        '<path d="M2.6 6.9a1.6 1.6 0 0 1 1.6-1.6h4.2l1.9 2.1h9.1a1.6 1.6 0 0 1 ' +
        '1.6 1.6v9.1a1.6 1.6 0 0 1-1.6 1.6H4.2a1.6 1.6 0 0 1-1.6-1.6z"/>' +
        '<path d="M12 10.9v5.2M9.4 13.5h5.2"/>';
    }

    /* whatever element the theme uses for the counter, reuse it */
    var cnt = null;
    [].slice.call(a.children).forEach(function (child) {
      if (child.tagName !== 'I' && !child.querySelector('svg')) cnt = child;
    });
    if (cnt) {
      /* The clone arrives carrying data-js-wishlist-count. That attribute is a
         live hook: the theme's list engine writes into anything that has it,
         which would let the wishlist overwrite this number. Drop it. */
      cnt.removeAttribute('data-js-wishlist-count');
      cnt.removeAttribute('data-js-compare-count');
      cnt.setAttribute('data-mp-count', 'badge');
      cnt.textContent = '0';
    }

    cart.parentElement.insertAdjacentElement('beforebegin', wrap);
    paintCount();
  }

  /* The top bar carried a "Client Services" link that went nowhere: href="#",
     and clicking it opened a demo popup. It is rewritten in place rather than
     hidden and replaced, so it keeps the theme's own type, colour and spacing
     and cannot drift from "Register or Sign in" sitting next to it. */
  function mountTopBarLink() {
    var a = document.querySelector('.header__line-additional_button--services');
    if (!a || a.hasAttribute('data-mp-topbar')) return;

    a.setAttribute('href', '/pages/my-projects');
    a.setAttribute('data-mp-topbar', '');
    /* unhook the popup, or the click opens the demo panel instead of navigating */
    a.classList.remove('js-popup-button');
    a.removeAttribute('data-js-popup-button');
    a.removeAttribute('data-js-trigger');

    a.textContent = '';
    var label = document.createElement('span');
    label.textContent = 'My Projects';
    a.appendChild(label);

    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.setAttribute('style',
      'width:15px;height:15px;margin-left:7px;vertical-align:-2px;' +
      'fill:none;stroke:currentColor;stroke-width:1.7;' +
      'stroke-linecap:round;stroke-linejoin:round');
    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d',
      'M12 20.4 4.2 12.9a4.6 4.6 0 0 1 0-6.6 4.6 4.6 0 0 1 6.5 0l1.3 1.3 ' +
      '1.3-1.3a4.6 4.6 0 0 1 6.5 0 4.6 4.6 0 0 1 0 6.6z');
    svg.appendChild(path);
    a.appendChild(svg);
  }

  /* --------------------------------------------------------------- the page */

  function itemRowHtml(prod, item, readOnly) {
    if (!prod) {
      return '<div class="mp-item mp-item--gone"><div class="mp-item__b">' +
        '<p class="mp-item__t">This fixture is no longer in the store.</p>' +
        (readOnly ? '' : '<button class="mp-link" data-mp-remove="' + item.v + '">Remove</button>') +
        '</div></div>';
    }
    var variant = prod.variants.filter(function (v) { return v.id === item.v; })[0] || prod.variants[0];
    var img = (variant && variant.featured_image && variant.featured_image.src) ||
              prod.featured_image || (prod.images && prod.images[0]) || '';
    var line = variant.price * (item.q || 1);
    return '<div class="mp-item" data-v="' + item.v + '">' +
      '<a class="mp-item__i" href="' + esc(prod.url) + '">' +
        (img ? '<img src="' + esc(sized(img, 220)) + '" alt="">' : '') +
      '</a>' +
      '<div class="mp-item__b">' +
        '<a class="mp-item__t" href="' + esc(prod.url) + '">' + esc(prod.title) + '</a>' +
        (variant.title && variant.title !== 'Default Title'
          ? '<p class="mp-item__v">' + esc(variant.title) + '</p>' : '') +
        '<p class="mp-item__p">' + money(variant.price) + '</p>' +
        (variant.available ? '' : '<p class="mp-item__o">Out of stock</p>') +
      '</div>' +
      '<div class="mp-item__q">' +
        (readOnly
          ? '<span class="mp-qty-ro">Qty ' + (item.q || 1) + '</span>'
          : '<label class="mp-lab" for="q' + item.v + '">Qty</label>' +
            '<input id="q' + item.v + '" class="mp-qty" type="number" min="1" max="99" value="' + (item.q || 1) + '" data-mp-qty="' + item.v + '">') +
        '<p class="mp-item__line">' + money(line) + '</p>' +
        (readOnly ? '' : '<button class="mp-link" type="button" data-mp-remove="' + item.v + '">Remove</button>') +
      '</div>' +
    '</div>';
  }

  function renderProject(root, project, opts) {
    opts = opts || {};
    var readOnly = !!opts.readOnly;
    root.innerHTML = '<div class="mp-loading">Loading your fixtures…</div>';

    Promise.all(project.items.map(function (i) { return fetchProduct(i.h); }))
      .then(function (prods) {
        var total = 0, count = 0, missing = 0;
        project.items.forEach(function (item, n) {
          var prod = prods[n];
          if (!prod) { missing++; return; }
          var variant = prod.variants.filter(function (v) { return v.id === item.v; })[0] || prod.variants[0];
          total += variant.price * (item.q || 1);
          count += (item.q || 1);
        });

        var rows = project.items.map(function (item, n) {
          return itemRowHtml(prods[n], item, readOnly);
        }).join('');

        root.innerHTML =
          '<div class="mp-head">' +
            '<div>' +
              '<a class="mp-back" href="/pages/my-projects">&larr; All projects</a>' +
              '<h1 class="mp-title">' + esc(project.name) + '</h1>' +
              '<p class="mp-sub">' + project.items.length +
                (project.items.length === 1 ? ' fixture' : ' fixtures') +
                ' &middot; ' + count + ' total ' + (count === 1 ? 'unit' : 'units') +
                ' &middot; <b>' + money(total) + '</b>' +
                (missing ? ' &middot; ' + missing + ' no longer available' : '') +
              '</p>' +
              (readOnly ? '<p class="mp-note">Someone shared this project with you. ' +
                 'Saving it makes your own copy, so changes you make will not affect theirs.</p>' : '') +
            '</div>' +
            '<div class="mp-actions">' +
              '<button class="mp-btn" type="button" data-mp-cart>Add all to cart</button>' +
              (readOnly
                ? '<button class="mp-btn mp-btn--ghost" type="button" data-mp-save>Save to my projects</button>'
                : '<button class="mp-btn mp-btn--ghost" type="button" data-mp-share>Share</button>' +
                  '<button class="mp-btn mp-btn--ghost" type="button" data-mp-rename>Rename</button>' +
                  '<button class="mp-link mp-link--danger" type="button" data-mp-delete>Delete project</button>') +
            '</div>' +
          '</div>' +
          '<div class="mp-items">' + (rows || '<p class="mp-empty">Nothing in here yet.</p>') + '</div>';

        root.querySelectorAll('[data-mp-qty]').forEach(function (input) {
          input.addEventListener('change', function () {
            P.setQty(project.id, input.dataset.mpQty, input.value);
            renderProject(root, P.get(project.id), opts);
          });
        });

        root.addEventListener('click', function onClick(e) {
          var rm = e.target.closest('[data-mp-remove]');
          if (rm && !readOnly) {
            P.removeItem(project.id, rm.getAttribute('data-mp-remove'));
            renderProject(root, P.get(project.id), opts);
            return;
          }
          if (e.target.closest('[data-mp-cart]')) {
            var btn = e.target.closest('[data-mp-cart]');
            btn.disabled = true;
            btn.textContent = 'Adding…';
            P.addAllToCart(project).then(function (res) {
              btn.disabled = false;
              btn.textContent = 'Add all to cart';
              if (res.ok) { location.href = '/cart'; return; }
              if (res.reason === 'empty') { toast('This project is empty.'); return; }
              var why = (res.body && res.body.description) || 'Some fixtures could not be added.';
              toast(why, 'bad');
            });
            return;
          }
          if (e.target.closest('[data-mp-share]')) {
            var url = P.shareUrl(project);
            /* The whole project rides in the URL, which is what makes sharing
               work with no account and no backend. The cost is length: about
               90 characters per fixture. Browsers and mail clients start
               mangling links past roughly 2000, so past that we say so
               instead of handing over something that silently breaks. */
            if (url.length > 1800) {
              openModal('This project is too big to share as a link',
                '<p class="mp-empty">A shared link carries the whole project inside it, ' +
                'and at ' + project.items.length + ' fixtures this one comes to ' + url.length +
                ' characters. Email programs cut links around 2000 and the recipient would ' +
                'get a broken one.</p><p class="mp-empty">Split it into two projects, ' +
                'or send the list as text.</p>' +
                '<div class="mp-row mp-row--end"><button class="mp-btn" type="button" data-mp-txt>Copy as text</button></div>',
                function (body) {
                  body.querySelector('[data-mp-txt]').addEventListener('click', function () {
                    Promise.all(project.items.map(function (i) { return fetchProduct(i.h); }))
                      .then(function (prods) {
                        var lines = project.name + '\n\n' + project.items.map(function (it, n) {
                          var pr = prods[n];
                          return (it.q || 1) + ' x ' + (pr ? pr.title : it.h) +
                                 '\n   ' + location.origin + '/products/' + it.h;
                        }).join('\n');
                        try { navigator.clipboard.writeText(lines); toast('Copied as text', 'ok'); }
                        catch (err) { toast('Could not copy. Select it by hand.', 'bad'); }
                        closeModal();
                      });
                  });
                });
              return;
            }
            openModal('Share this project', shareHtml(url), function (body) {
              var input = body.querySelector('.mp-in');
              input.select();
              body.querySelector('[data-mp-copy]').addEventListener('click', function () {
                input.select();
                try {
                  navigator.clipboard.writeText(url);
                  toast('Link copied', 'ok');
                } catch (err) {
                  document.execCommand('copy');
                }
              });
            });
            return;
          }
          if (e.target.closest('[data-mp-rename]')) {
            openModal('Rename project',
              '<form class="mp-new"><div class="mp-row">' +
              '<input class="mp-in" type="text" maxlength="60" value="' + esc(project.name) + '">' +
              '<button class="mp-btn" type="submit">Save</button></div></form>',
              function (body) {
                var input = body.querySelector('.mp-in');
                input.focus(); input.select();
                body.querySelector('form').addEventListener('submit', function (ev) {
                  ev.preventDefault();
                  P.rename(project.id, input.value);
                  closeModal();
                  renderProject(root, P.get(project.id), opts);
                });
              });
            return;
          }
          if (e.target.closest('[data-mp-delete]')) {
            openModal('Delete this project?',
              '<p class="mp-empty">' + esc(project.name) + ' and its ' + project.items.length +
              ' saved ' + (project.items.length === 1 ? 'fixture' : 'fixtures') +
              ' will be removed. This cannot be undone.</p>' +
              '<div class="mp-row mp-row--end"><button class="mp-btn mp-btn--ghost" type="button" data-mp-cancel>Keep it</button>' +
              '<button class="mp-btn mp-btn--danger" type="button" data-mp-confirm>Delete</button></div>',
              function (body) {
                body.querySelector('[data-mp-cancel]').addEventListener('click', closeModal);
                body.querySelector('[data-mp-confirm]').addEventListener('click', function () {
                  P.remove(project.id);
                  closeModal();
                  location.href = '/pages/my-projects';
                });
              });
            return;
          }
          if (e.target.closest('[data-mp-save]')) {
            var copy = P.create(project.name);
            if (!copy) { toast('Too many projects already.'); return; }
            project.items.forEach(function (i) { P.addItem(copy.id, i.v, i.h, i.q); });
            toast('Saved as your own copy', 'ok');
            location.href = '/pages/my-projects?project=' + copy.id;
          }
        }, { once: true });
      });
  }

  function shareHtml(url) {
    return '<p class="mp-empty">Anyone with this link can see the fixtures and add them to their ' +
      'own cart. They do not need an account, and they cannot change your copy.</p>' +
      '<div class="mp-row"><input class="mp-in" type="text" readonly value="' + esc(url) + '">' +
      '<button class="mp-btn" type="button" data-mp-copy>Copy</button></div>' +
      '<p class="mp-fine"><a href="mailto:?subject=' + encodeURIComponent('Lighting project') +
      '&body=' + encodeURIComponent(url) + '">Send it by email instead</a></p>';
  }

  function renderList(root) {
    var list = P.all();
    if (!list.length) {
      root.innerHTML =
        '<div class="mp-zero">' +
          '<h1 class="mp-title">My Projects</h1>' +
          '<p class="mp-sub">Save fixtures into named lists as you browse. One list per room, ' +
            'per job, per client, whichever way you work.</p>' +
          '<p class="mp-sub">Open any fixture and choose <b>Add to Project</b>. ' +
            'Your first project can be created right there.</p>' +
          '<a class="mp-btn" href="/collections/all">Browse lighting</a>' +
        '</div>';
      return;
    }
    root.innerHTML =
      '<div class="mp-head"><div><h1 class="mp-title">My Projects</h1>' +
      '<p class="mp-sub">' + list.length + (list.length === 1 ? ' project' : ' projects') + '</p></div>' +
      '<div class="mp-actions"><button class="mp-btn mp-btn--ghost" type="button" data-mp-newproject>New project</button></div></div>' +
      '<div class="mp-grid">' + list.map(function (p) {
        return '<a class="mp-tile" href="/pages/my-projects?project=' + esc(p.id) + '">' +
          '<div class="mp-tile__thumbs" data-thumbs="' + esc(p.id) + '"></div>' +
          '<p class="mp-tile__n">' + esc(p.name) + '</p>' +
          '<p class="mp-tile__c">' + p.items.length + (p.items.length === 1 ? ' fixture' : ' fixtures') + '</p>' +
        '</a>';
      }).join('') + '</div>';

    root.querySelector('[data-mp-newproject]').addEventListener('click', function () {
      openModal('New project',
        '<form class="mp-new"><div class="mp-row">' +
        '<input class="mp-in" type="text" maxlength="60" placeholder="Kitchen remodel">' +
        '<button class="mp-btn" type="submit">Create</button></div></form>',
        function (body) {
          var input = body.querySelector('.mp-in');
          input.focus();
          body.querySelector('form').addEventListener('submit', function (e) {
            e.preventDefault();
            var p = P.create(input.value);
            closeModal();
            if (p) location.href = '/pages/my-projects?project=' + p.id;
          });
        });
    });

    list.forEach(function (p) {
      var box = root.querySelector('[data-thumbs="' + p.id + '"]');
      if (!box) return;
      Promise.all(p.items.slice(0, 4).map(function (i) { return fetchProduct(i.h); }))
        .then(function (prods) {
          var cells = prods.filter(Boolean).map(function (pr) {
            var img = pr.featured_image || (pr.images && pr.images[0]);
            return img ? '<span class="mp-th"><img src="' + esc(sized(img, 320)) + '" alt=""></span>' : '';
          }).filter(Boolean);
          /* A fixed 2x2 grid holding one image left a dead grey half-tile, so
             the collage follows the number of images it actually got. */
          box.setAttribute('data-n', String(cells.length));
          box.innerHTML = cells.join('') || '<span class="mp-th mp-th--none"></span>';
        });
    });
  }

  /* The theme prints its own <h1> for the page, which says "My Projects" too.
     Two identical H1s on one page is wrong for search engines and reads as a
     stutter. Ours is the one to keep: on a project it carries that project's
     name. Only ever runs on this page, since renderPage needs #moose-projects. */
  function hideThemeTitle() {
    var t = document.querySelector('.page__title');
    if (t) t.style.display = 'none';
  }

  function renderPage() {
    var root = document.getElementById('moose-projects');
    if (!root) return;
    hideThemeTitle();
    var qs = new URLSearchParams(location.search);
    var shared = qs.get('shared');
    var pid = qs.get('project');

    if (shared) {
      var proj = P.decode(shared);
      if (!proj) {
        root.innerHTML = '<div class="mp-zero"><h1 class="mp-title">That link did not work</h1>' +
          '<p class="mp-sub">The project link looks damaged or incomplete. Ask whoever sent it to share it again.</p>' +
          '<a class="mp-btn" href="/pages/my-projects">Go to my projects</a></div>';
        return;
      }
      renderProject(root, proj, { readOnly: true });
      return;
    }
    if (pid) {
      var p = P.get(pid);
      if (!p) { location.href = '/pages/my-projects'; return; }
      renderProject(root, p, {});
      return;
    }
    renderList(root);
  }

  /* ------------------------------------------------------------------ boot */

  wireProductButtons();
  mountHeaderLink();
  mountTopBarLink();
  /* the sticky header swaps its own markup in on scroll, taking the clone
     with it, so watch for that and put it back */
  if (window.MutationObserver) {
    var hdr = document.querySelector('.header, header');
    if (hdr) new MutationObserver(function () {
      mountHeaderLink();
      mountTopBarLink();
    }).observe(hdr, { childList: true, subtree: true });
  }
  P.on(paintCount);
  paintCount();

  if (document.getElementById('moose-projects')) {
    if (P.ready) renderPage();
    else P.on(function once() { renderPage(); });
  }
})();
